export const regEn = {
  finishTitle: 'Complete registration',
  company: 'Company',
  companyPl: 'Your company name',
  enter: 'Enter',
  companyErr: 'Enter your company name',
  exampleProject: 'Example Project',
  exampleBoard: 'My board',
  exampleColumn1: 'New',
  exampleColumn2: 'In Progress',
  exampleColumn3: 'Done',
  companyLinkInviteText: 'Or send this link to your colleagues',
  projectParticipants: 'Project Participants',
  workerEmail: 'invited e-mail',
  notDistributed: 'Not distibuted users',
  cantRegisterEmail: 'Failed to register',
  companyLabel: 'Choose your company name',
  companyPlaceholder: 'Company name',
  usernameLabel: 'Your name',
  usernamePlaceholder: 'Enter your name here',
  phoneLabel: 'Your contact phone',
  phonePlaceholder: 'Enter your phone here',
  failSignInWithGoogle: 'Failed to sign in with Google',
  accountDisabledGoogle: 'Account is removed',
  boardDevTitle: 'Developer',
  boardDevCol1: 'Backlog',
  boardDevCol2: 'В работе',
  boardDevCol3: 'Готово',

  stopwatchSticker: 'Секундомер',
  sprintSticker: 'Спринт',
  priorSticker: 'Приоритет',
  criticalPrio: 'critical',
  majorPrio: 'major',
  normalPrio: 'normal',
  minorPrio: 'low',

  taskTypeSticker: 'Тип задачи',
  taskTypeStickerStFeature: 'Фича',
  taskTypeStickerStBug: 'Баг',

  sectionSticker: 'Раздел',
  commentSticker: 'Комментарий',
  deviceSticker: 'Устройство',
  mobDeviceSticker: 'Mobile',
  webDeviceSticker: 'Web',
  mobWebDeviceSticker: 'Mobile&Web',

  estimationSticker: 'Оценка в днях',

  boardDev: {
    boardDevCol1Task1Title: 'Изменение масштаба в осевой диаграмме',
    boardDevCol1Task1Sub1Title: 'изменение масштаба оси при выборе значений',
    boardDevCol1Task1Sub2Title: 'плавный переход при изменении масштаба',
    boardDevCol1Task1Sub3Title: 'ползунки для выбора диапазон значений по оси',
    boardDevCol1Task2Title:
      'Фильтр отображения данных: чек-боксы в круговой диаграмме',
    boardDevCol1Task3Title:
      'Выбор цвета диаграммы: кастомные цвета отображения данных',
    boardDevCol1Task3Sub1Title:
      'Разработка механизма для сохранения выбранных пользователем цветов для каждой категории данных',

    boardDevCol2Task1Title:
      'Неправильное отображение всплывающих подсказок в дашборде',
    /*     boardDevCol2Task2Title:
      'Разработка механизма для сохранения выбранных пользователем цветов для каждой категории данных',
    boardDevCol2Task2Sub1Title: 'Валидация формы', */

    boardDevCol2Task3Title: 'Вёрстка главной страницы',

    boardDevCol2Task3Sub1Title: 'Верстка хэдера и футера',
    boardDevCol2Task3Sub2Title: 'Создание адаптива',
    boardDevCol2Task3Sub3Title:
      'Оптимизация превью для различных разрешений экрана',

    boardDevCol3Task1Title:
      'Оптимизация производительности визуализации данных',
    boardDevCol3Task2Title: 'Retro meeting',
    boardDevCol3Task3Title: 'Добавить свой шрифт в настройки',
    boardDevCol3Task4Title: 'Тёмная тема: фикс теней при переключении',
    boardDevCol3Task5Title:
      'Интеграция библиотеки для отображения графиков и диаграмм',
    boardDevCol3Task6Title:
      'Неправильное отображение данных при входе на мобильном по ссылке-приглашению',
    boardDevCol3Task7Title: 'всплывающая подсказка для иконки превью',
    boardDevCol3Task8Title: 'Полноэкранное отображение панели с фильтрами',
    inProgressMoveTemplate: 'В работу'
  },

  boardTeamTitle: 'Сайт для зоомагазина',
  boardTeamCol1: 'Работа над концепцией',
  boardTeamCol2: 'Дизайн',
  boardTeamCol3: 'Тестирование',
  boardTeamCol4: 'Готово',

  boardTeam: {
    col1Task1Title: 'Управление доступом к дашбордам: дефолтные роли',
    col1Task2Title: 'Фильтры данных в диаграммах',
    col1Task3Title: 'Уведомления об изменениях данных на дашборде',
    col1Task4Title: 'Ссылка-приглашение на дашборд пользователя',
    col1Task5Title: 'Progress bar при импорта из CVS тёмная тема',
    col1Task6Title:
      'Предварительный просмотр диаграммы до применения настройки',
    col1Task7Title: 'Визуализация данных на географической карте',
    col1Task8Title: 'Настройка аватарки в аккаунте',

    col2Task1Title: 'Анимации-превью для видов диаграмм',
    col2Task2Title: 'Прототип дашборда в примере отчёта',

    col3Task1Title: 'Уведомления о изменении данных на email',
    col3Task2Title: 'Не работает компонент отображения маршрута',
    col3Task2Sub1Title:
      'правильность входных данных, которые должны передаваться в компонент отображения маршрута (координаты, маршруты, точки)',
    col3Task2Sub2Title: 'Настройка конфигурации компонента',
    col3Task3Title: 'Bubble chart',

    bugTemplate: 'Баг'
  }
}
